module.exports = [
  { id: "218", word: "settimo" },
  { id: "238", word: "la bolletta" },
  { id: "274", word: "sei" },
  { id: "323", word: "il libero scambio" },
  { id: "389", word: "critico" },
  { id: "578", word: "l’app" },
  { id: "702", word: "scalare" },
  { id: "830", word: "il giocatore" },
  { id: "1540", word: "la giostra" },
  { id: "2096", word: "presumere" },
  { id: "2180", word: "il capitalismo" },
  { id: "2207", word: "la scherma" },
  { id: "2213", word: "il comunismo" },
  { id: "2259", word: "preparare un infuso" },
  { id: "2345", word: "il socialismo" },
  { id: "2496", word: "la fila" },
  { id: "2528", word: "l’individuo" },
  { id: "2750", word: "l’antidolorifico" },
  { id: "2899", word: "la mora" },
  { id: "2999", word: "la globalizzazione" },
  { id: "3012", word: "il processo" },
  { id: "3049", word: "la guardia carceraria" },
  { id: "3057", word: "lo spazio" },
  { id: "3136", word: "il fallimento" },
  { id: "3144", word: "l’unità" },
  { id: "3156", word: "la criptovaluta" },
  { id: "3164", word: "il femminismo" },
  { id: "3242", word: "la tubercolosi" },
  { id: "3424", word: "il colpo di stato" },
  { id: "3428", word: "la vodka" },
  { id: "3450", word: "i diritti umani" },
  { id: "3464", word: "il proverbio" },
  { id: "3470", word: "il trampolino" },
  { id: "3474", word: "lo sponsor" },
  { id: "3475", word: "l’ipotesi" },
  { id: "3476", word: "ritornare" },
  { id: "3488", word: "il fidanzato" },
  { id: "3489", word: "la pasta" },
  { id: "3499", word: "il pompelmo" }
];



// WEBPACK FOOTER //
// ./src/containers/Words/it.js